import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter } from 'react-router-dom';
import { RouterProvider } from 'react-router-dom';
import WatchPage from './components/WatchPage';
import MainContainer from './components/MainContainer';
import SearchResults from './components/SearchResults';
import Body from "./components/Body" ;

const appRouter = createBrowserRouter([

    {
      path : "/",
      element : <App />,
      children : [
     {
      path : "/" , 
      element : <Body />,
      children : [
      { 
         path : "/watchpage",
         element : <WatchPage />
      }, 
      {
        path : "/",
        element : <MainContainer />
      },
      {
        path : 'results',
        element : <SearchResults />
      }
     ]
    },
   ]
   }]) ; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    < RouterProvider router={appRouter}/>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
